"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import { useSearchqueryState } from "@repo/design-system/hooks/use-searchquery-state";
import { getHighlightedTitle, useAutocomplete } from "@repo/design-system/lib/auto-complete/client";
import type { Item } from "@repo/design-system/lib/react-query/api";
import { cn } from "@repo/design-system/utils/cn";
import { useState } from "react";
import { Autocomplete, AutocompleteClear, AutocompleteContent, AutocompleteEmpty, AutocompleteInput, AutocompleteInputGroup, AutocompleteItem, AutocompleteList } from "~/components/ui/autocomplete-eon";
import { ComboboxFloatingLabel } from "~/components/ui/combobox-eon";
import { useLanguage } from "~/translations/loader/use-language";
export function Searchbar(t0) {
  const $ = _c(37);
  const {
    className
  } = t0;
  const locale = useLocale();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useSearchqueryState();
  const t = useLanguage();
  const t1 = search || "";
  let t2;
  if ($[0] !== locale || $[1] !== t1) {
    t2 = {
      inputValue: t1,
      locale
    };
    $[0] = locale;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: items,
    isLoading
  } = useAutocomplete(t2);
  const floating = open || !!search;
  let t3;
  if ($[3] !== className) {
    t3 = cn("relative", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== floating || $[6] !== t.filterbar_searchLabel) {
    t4 = <ComboboxFloatingLabel floating={floating} htmlFor="search">{t.filterbar_searchLabel}</ComboboxFloatingLabel>;
    $[5] = floating;
    $[6] = t.filterbar_searchLabel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== items) {
    t5 = items || [];
    $[8] = items;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== setSearch) {
    t6 = val => setSearch(val || null);
    $[10] = setSearch;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = search || "";
  const t8 = floating ? t.filterbar_filter1_placeholder_search : "";
  let t9;
  if ($[12] !== t8) {
    t9 = <AutocompleteInput id="search" placeholder={t8} />;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== search || $[15] !== setSearch) {
    t10 = search && <AutocompleteClear onClick={async e => {
      e.stopPropagation();
      await setSearch(null);
    }} />;
    $[14] = search;
    $[15] = setSearch;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== open || $[18] !== t10 || $[19] !== t9) {
    t11 = <AutocompleteInputGroup open={open}>{t9}{t10}</AutocompleteInputGroup>;
    $[17] = open;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = isLoading ? t.filterbar_filter1_placeholder_search : t.filtermenu_noOptions;
  let t13;
  if ($[21] !== t12) {
    t13 = <AutocompleteEmpty>{t12}</AutocompleteEmpty>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <AutocompleteList>{_temp2}</AutocompleteList>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13) {
    t15 = <AutocompleteContent>{t13}{t14}</AutocompleteContent>;
    $[24] = t13;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== open || $[27] !== t11 || $[28] !== t15 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7) {
    t16 = <Autocomplete items={t5} itemToStringValue={_temp} onOpenChange={setOpen} onValueChange={t6} open={open} value={t7}>{t11}{t15}</Autocomplete>;
    $[26] = open;
    $[27] = t11;
    $[28] = t15;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16 || $[34] !== t3 || $[35] !== t4) {
    t17 = <div className={t3}>{t4}{t16}</div>;
    $[33] = t16;
    $[34] = t3;
    $[35] = t4;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}
function _temp2(item_0, index) {
  return <AutocompleteItem key={`${item_0.document.data.idClient || index}`} value={item_0}><div dangerouslySetInnerHTML={{
      __html: getHighlightedTitle(item_0)
    }} /></AutocompleteItem>;
}
function _temp(item) {
  return item.document.data.title;
}